import React from 'react';
import { TextField } from "@material-ui/core";
export default function CustomTextField(props) { 
    return (
        <TextField
            type={props.type}
            style={{ width: '100%' }} 
            label={props.label}
            required={props.required}
            disabled={props.disabled}
            multiline={props.multiline}
            placeholder={props.placeholder}
            variant={props.variant}
            value={props.value}
            helperText={props.helperText}
            error={props.error}
            inputProps={{
                style: {
                    fontSize: 14,
                    fontFamily: 'Poppins',
                }
            }}
            onClick={()=> props.onClick ? props.onClick() : null}
            onChange={(e)=> {
                props.onChange(e.target.value)
            }}
            InputLabelProps={{
                style: {
                    fontSize: 14,
                    color: '#7e8085',
                    fontFamily: 'Poppins',
                }
            }}
            InputProps={props.InputProps}
            defaultValue={props.defaultValue}
        />
    )
}